<i18n>
{
    "en": {
        "Day": "Day",
		"Month": "Month"
    },
    "vi": {
        "Day": "Ngày",
		"Month": "Tháng"
	}
		
}
</i18n>

<template>
	<div class="select-time-of-the-month flex justify-start items-baseline">
		<div class="mb-3 sm:mb-0 sm:mr-3">
			<select-ordinarily-day
				:required="required"
				v-model="localValue"
				:dayLabel="dayLabel"
				:dayPlaceholder="dayPlaceholder"
				:ordinarilyLabel="ordinarilyLabel"
				:ordinarilyPlaceholder="ordinarilyPlaceholder"
			/>
		</div>
		<p class="whitespace-no-wrap">{{ $t("Of") }}</p>
		<div class="ml-3">
			<!-- <legend class="vs-input--label" v-if="monthLabel">{{ monthLabel }} <span class="text-danger">*</span>:</legend> -->
			<cbs-select-month filterable name="month23" class="w-full" v-validate="required" v-model="localByMonthValue" :data-vv-as="$t(monthLabel)" :placeholder="monthPlaceholder" />
			<span class="text-danger text-sm break-normal" v-show="errors.has('month23')">{{ errors.first("month23") }}</span>
		</div>
	</div>
</template>

<script>
import SelectOrdinarilyDay from "./SelectOrdinarilyDay";
import CbsSelectMonth from "@/components/cbs-select-month/CbsSelectMonth";

export default {
	name: "SelectTimeOfTheMonth",
	inject: ["parentValidator"],
	components: {
		CbsSelectMonth,
		SelectOrdinarilyDay
	},
	props: {
		value: {
			type: Object,
			required: true
		},
		dayLabel: {
			type: String,
			default: "Day"
		},
		monthLabel: {
			type: String,
			default: "Month"
		},
		ordinarilyLabel: {
			type: String,
			default: "Ordinarily"
		},
		dayPlaceholder: String,
		monthPlaceholder: String,
		ordinarilyPlaceholder: String,
		required: { type: String, default: "" }
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localByMonthValue: {
			get() {
				return this.localValue.bymonth;
			},
			set(val) {
				this.localValue = {
					...this.localValue,
					bymonth: val
				};
			}
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
